import {gettext} from '../../../gettextMarker.function';

export function createMenu(cbEdit, cbCopy, cbDelete, cbOpenInNewWindow, cbOpenInNewTab, ngxTranslateService) {
  return   [
    {
      label: ngxTranslateService.instant(gettext('Change')),
      command: cbEdit
    },
    {
      label: ngxTranslateService.instant(gettext('Delete')),
      command: cbDelete
    },
    {
      label: ngxTranslateService.instant(gettext('Open in new window')),
      command: cbOpenInNewWindow
    },
    {
      label: ngxTranslateService.instant(gettext('Open in new tab')),
      command: cbOpenInNewTab
    }
  ];
}
